import React from 'react';

type Props = {
  quote: string;
  name: string;
  role: string;
  logo: React.ReactNode;
};

function TestimonialCard({ quote, name, role, logo }: Props) {
  return (
    <figure className="flex flex-col justify-between gap-4 rounded-2xl bg-white p-6 font-lexend">
      <div className="flex h-7 items-center self-start text-retino-darkviolet [&>img]:h-full [&>img]:w-auto">
        {logo}
      </div>
      <blockquote className="grow">
        <p className="text-sm leading-snug text-black">{quote}</p>
      </blockquote>
      <figcaption>
        <p className="text-sm font-semibold text-black">{name}</p>
        <p className="text-xs text-black">{role}</p>
      </figcaption>
    </figure>
  );
}

export default TestimonialCard;
